import React from 'react';

import { Button } from '../atoms/button';

export interface Props {
  prevButtonText?: string;
  prevButtonDisabled?: boolean;
  onPrevButtonPress?: () => void;
  nextButtonText?: string;
  nextButtonDisabled?: boolean;
  onNextButtonPress?: () => void;
  disclaimer?: React.ReactNode | React.ReactNodeArray;
  isLoading?: boolean;
}

export const OrderButtons: React.FC<Props> = (props) => {
  let {
    prevButtonText,
    prevButtonDisabled,
    onPrevButtonPress,
    nextButtonText,
    nextButtonDisabled,
    onNextButtonPress,
    disclaimer,
    isLoading,
  } = props;

  return (
    <div className="w-full">
      {disclaimer && <div className="my-4 text-gray-600 font-medium text-center text-sm">{disclaimer}</div>}
      <div className="flex">
        {prevButtonText && (
          <Button onPress={onPrevButtonPress} size="lg" disabled={prevButtonDisabled} isLoading={isLoading}>
            {prevButtonText}
          </Button>
        )}
        {prevButtonText && nextButtonText && <div className="w-4"></div>}
        {nextButtonText && (
          <Button
            onPress={onNextButtonPress}
            size="lg"
            appearance="primary"
            disabled={nextButtonDisabled}
            isLoading={isLoading}
          >
            {nextButtonText}
          </Button>
        )}
      </div>
    </div>
  );
};
